export default (el) => {
  let label = el.querySelector('label'),
      input = el.querySelector('input');

  if (label && input && input.id) {
    label.setAttribute('for', input.id);
  }
};